var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 3.75C7.29167 3.29167 7.54167 3.04167 8 3C8.45833 3.04167 8.70833 3.29167 8.75 3.75V7.59375L11.4062 9.375C11.7812 9.66667 11.8438 10.0104 11.5938 10.4062C11.3229 10.7812 10.9896 10.8438 10.5938 10.5938L7.59375 8.59375C7.36458 8.46875 7.25 8.26042 7.25 7.96875V3.75ZM8 0C9.5 0.0208333 10.8438 0.385417 12.0312 1.09375C13.2396 1.80208 14.1979 2.76042 14.9062 3.96875C15.6146 5.15625 15.9792 6.5 16 8C15.9792 9.5 15.6146 10.8438 14.9062 12.0312C14.1979 13.2396 13.2396 14.1979 12.0312 14.9062C10.8438 15.6146 9.5 15.9792 8 16C6.5 15.9792 5.15625 15.6146 3.96875 14.9062C2.76042 14.1979 1.80208 13.2396 1.09375 12.0312C0.385417 10.8438 0.0208333 9.5 0 8C0.0208333 6.5 0.385417 5.15625 1.09375 3.96875C1.80208 2.76042 2.76042 1.80208 3.96875 1.09375C5.15625 0.385417 6.5 0.0208333 8 0ZM1.5 8C1.54167 9.83333 2.17708 11.3646 3.40625 12.5938C4.63542 13.8229 6.16667 14.4583 8 14.5C9.83333 14.4583 11.3646 13.8229 12.5938 12.5938C13.8229 11.3646 14.4583 9.83333 14.5 8C14.4583 6.16667 13.8229 4.63542 12.5938 3.40625C11.3646 2.17708 9.83333 1.54167 8 1.5C6.16667 1.54167 4.63542 2.17708 3.40625 3.40625C2.17708 4.63542 1.54167 6.16667 1.5 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a4be86f776a20901be5b79773782cc5b.svg";
export { ForwardRef as ReactComponent };